<div class="group">
    
    <p class="group-caption">
        @if (showFavoriteIcon()) {
            <svg class="fav-icon" fill="currentColor" outline="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
        }
        {{caption()}}
    </p>
    <hr class="group-divider">
    <ng-content></ng-content>
</div>